import { PhoneOutlined } from "@ant-design/icons";
import { Input, Select, Space } from "antd";
import { useEffect, useState } from "react";

const MoroccanPhoneInput: React.FC<{
  value?: string;
  onChange?: (value: string) => void;
}> = ({ value = "", onChange }) => {
  // Ensure value is a string to prevent errors
  const safeValue = typeof value === "string" ? value : "";

  const [prefix, setPrefix] = useState<string>(
    safeValue[0] === "0" ? safeValue.slice(1, 2) : safeValue.slice(0, 1) || "6"
  );

  const [phoneNumber, setPhoneNumber] = useState<string>(
    safeValue.length > 2 ? safeValue.slice(2) : ""
  );
  console.log("safeValue:", safeValue);
  console.log("safeValue.slice(2):", safeValue.slice(2));
  console.log("prefix", prefix, "phoneNumber", phoneNumber);

  useEffect(() => {
    setPrefix(
      safeValue[0] === "0"
        ? safeValue.slice(1, 2)
        : safeValue.slice(0, 1) || "6"
    );
    setPhoneNumber(safeValue.length > 2 ? safeValue.slice(2) : "");
  }, [safeValue]);

  const formatPhoneNumber = (value: string): string => {
    const digits = value.replace(/\D/g, "");
    const parts = [
      digits.slice(0, 2),
      digits.slice(2, 4),
      digits.slice(4, 6),
      digits.slice(6, 8),
    ];
    return parts.filter((part) => part.length > 0).join(" ");
  };

  const handlePrefixChange = (value: string) => {
    setPrefix(value);
    handleChange("0" + value + phoneNumber);
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhoneNumber(e.target.value);
    setPhoneNumber(formatted);
    handleChange("0" + prefix + formatted);
  };

  const handleChange = (value: string) => {
    if (onChange) {
      onChange(value);
    }
  };

  const prefixSelector = (
    <Select value={prefix} onChange={handlePrefixChange} style={{ width: 100 }}>
      <Select.Option value="5">+212 5</Select.Option>
      <Select.Option value="6">+212 6</Select.Option>
      <Select.Option value="7">+212 7</Select.Option>
    </Select>
  );

  return (
    <Space direction="vertical" size="small" style={{ display: "flex" }}>
      <Input
        value={phoneNumber}
        onChange={handlePhoneChange}
        addonBefore={prefixSelector}
        placeholder="xx-xx-xx-xx"
        maxLength={11}
        style={{ width: "100%" }}
        prefix={<PhoneOutlined />}
      />
    </Space>
  );
};

export default MoroccanPhoneInput;
